<template>
  <div class="all-ll">
    <div class="Breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item class="is-l" :to="{ path: '/Home' }"
          >首页</el-breadcrumb-item
        >
        <el-breadcrumb-item class="is-l" :to="{ path: '/' }"
          >实盘人数多空比</el-breadcrumb-item
        >
        <el-breadcrumb-item>历史数据</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="assets-tittle">实盘人数多空比</div>
    <div class="total-list">
      <div class="total-list-mg">
        <div class="assets-header">
          <div class="assets-bnt">
            <div class="block">
              <span class="demonstration">起止时间</span>
              <el-date-picker
                v-model="crrateTime"
                popper-class="elDatePicker"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                :picker-options="pickerOptions"
                end-placeholder="结束日期"
                @change="GetTime"
                align="right"
              >
              </el-date-picker>
            </div>
          </div>
        </div>
        <div class="assets-body">
          <div class="charts">
            <div class="right-control" v-show="this.Isvip == 2">
              {{ isVipMsg }}
            </div>
            <chart
              v-show="this.Isvip !== 2"
              class="chart"
              :option="countOption"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getScalelist } from '@/api/Home.js';
import Chart from '../echarts/chart.vue';
export default {
  components: { Chart },
  data() {
    return {
      countOption: {},
      pickerOptions: {
        pickerMinDate: '', // 第一次选中的时间
        onPick: (obj) => {
          this.pickerMinDate = new Date(obj.minDate).getTime();
        },
        disabledDate: (time) => {
          // if (this.pickerMinDate) {
          //   const day1 = 7 * 24 * 3600 * 1000;
          //   const maxTime = this.pickerMinDate + day1;
          //   const minTime = this.pickerMinDate - day1;
          //   return time.getTime() > maxTime || time.getTime() < minTime;
          // }
        },
      },
      crrateTime: [],
      timeValue: [],
      startTime: '',
      endTime: '',
      xData: [],
      longPositionrYData: [],
      notOpenYData: [],
      shortSellerYData: [],
      timeArr: [],
      Isvip: '',
      isVipMsg: '',
    };
  },
  async created() {
    await this.getDefaultTime();
    await this.getHistory();
    this.getCountData();
  },
  async mounted() {
    await this.getDefaultTime();
  },
  methods: {
    async getDefaultTime() {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      this.crrateTime = [start, end];
      this.startTime = this.formatDate(Date.parse(start), 'yyyy-MM-dd');
      this.endTime = this.formatDate(Date.parse(end), 'yyyy-MM-dd');
      this.pickerMinDate = this.startTime;
    }, // 重置
    async resetForm() {
      this.crrateTime = [];
      await this.getDefaultTime();
    },
    // 时间筛选
    async GetTime(e) {
      //console.log('时间重新筛选', e);
      this.startTime = e[0];
      this.endTime = e[1];
      await this.getHistory();
      this.getCountData();
    },
    //获取所有人数数据
    async getHistory() {
      //console.log('接口传的时间范围', this.startTime, this.endTime);
      const { data: res } = await getScalelist(this.startTime, this.endTime);

      if (res.code == 10006) {
        //this.$message.error(res.msg);
        this.Isvip = 2;
        this.isVipMsg = res.msg;
      } else {
        let resData = res.data;
        this.timeArr = resData.map((v) => v.createTime);
        this.xData = [];
        //console.log('还没格式化', this.timeArr);
        this.timeArr.forEach((e) => {
          this.xData.push(this.dateTypeFormat('YYYY-mm-dd HH:MM', new Date(e)));
        });
        this.timeArr = [];
        //console.log('格式化后：', this.xData);
        this.longPositionrYData = resData.map(
          (v) => v.personCount.longPersonsCount
        );
        this.notOpenYData = resData.map(
          (v) => v.personCount.noPositionPersonsCount
        );
        this.shortSellerYData = resData.map(
          (v) => v.personCount.shortPersonsCount
        );
        // console.log('多头', this.longPositionrYData);
        // console.log('未开', this.notOpenYData);
        // console.log('空头', this.shortSellerYData);
      }
    },
    getCountData() {
      const color = [
        'rgba(34, 171, 148, 1)',
        'rgba(209, 212, 220, 1)',
        'rgba(247, 82, 95, 1)',
      ];
      const xData = this.xData;
      const longPositionrYData = this.longPositionrYData; //多头
      const notOpenYData = this.notOpenYData; //未开仓
      const shortSellerYData = this.shortSellerYData; //空头
      this.countOption = {
        color: 'rgba(0, 174, 147, 1)',
        legend: {
          itemHeight: 16,
          itemWidth: 16,
          itemGap: 40,
          icon: 'roundRect',
          data: ['多头', '未开仓', '空头'],
          textStyle: {
            fontSize: 14,
            color: 'rgba(209, 212, 220, 1)',
          },
        },
        tooltip: {
          trigger: 'axis',
          borderWidth: '0', //边框宽度设置1
          borderColor: 'none', //设置边框颜色
          //formatter: '{b} <br/><br/>{a0}:{c0}%<br/>{a1}:{c1}%<br/>{a2}:{c2}%',
          formatter(params) {
            let str = ' ';
            str += `<div>${params[0].name}</div></br>`;
            for (let i = 0; i < params.length; i += 1) {
              str += `${params[i].marker}  <span>${params[i].seriesName}</span> : <span>${params[i].data}%</br>`;
            }
            return str;
          },
          padding: 20,
          textStyle: {
            fontSize: 16,
            fontWeight: 'normal',
            color: 'rgba(209, 212, 220, 1)', //设置文字颜色
          },
          extraCssText: 'background:rgba(61, 63, 71, 1);',
        },
        grid: {
          left: '1%',
          right: '3%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: xData,
          offset: 12,
          axisLabel: {
            textStyle: {
              color: 'rgba(209, 212, 220, 1)',
            },
          },
        },
        yAxis: {
          type: 'value',
          min: 'dataMin',
          max: 'dataMax',
          offset: 12,
          splitLine: {
            lineStyle: {
              // 使用深浅的间隔色
              color: ['rgba(159, 159, 159, 0.1)'],
            },
          },
          axisLabel: {
            formatter: '{value} %',
            textStyle: {
              color: 'rgba(209, 212, 220, 1)',
            },
          },
        },
        series: [
          {
            name: '多头',
            data: longPositionrYData,
            type: 'line',
            showSymbol: false, //   去除折线圆点
            lineStyle: {
              color: 'rgba(34, 171, 148, 1)',
            },
            itemStyle: {
              color: 'rgba(34, 171, 148, 1)',
            },
            areaStyle: {
              normal: {
                color: {
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0.1,
                      color: 'rgba(0, 174, 147, 0.2000)', // 0% 处的颜色
                    },
                    {
                      offset: 0.9,
                      color: 'rgba(0, 174, 147, 0)', // 100% 处的颜色
                    },
                  ],
                  globalCoord: false, // 缺省为 false
                },
              },
            },
          },
          {
            name: '未开仓',
            data: notOpenYData,
            type: 'line',
            showSymbol: false, //   去除折线圆点
            lineStyle: {
              color: 'rgba(209, 212, 220, 1)',
            },
            itemStyle: {
              color: 'rgba(209, 212, 220, 1)',
            },
            areaStyle: {
              normal: {
                color: {
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0.1,
                      color: 'rgba(209, 212, 220, 0)', // 0% 处的颜色
                    },
                    {
                      offset: 0.9,
                      color: 'rgba(209, 212, 220, 0.2000)', // 100% 处的颜色
                    },
                  ],
                  globalCoord: false, // 缺省为 false
                },
              },
            },
          },
          {
            name: '空头',
            data: shortSellerYData,
            type: 'line',
            showSymbol: false,
            lineStyle: {
              color: 'rgba(247, 82, 95, 1)',
            },
            itemStyle: {
              color: 'rgba(247, 82, 95, 1)',
            },
            areaStyle: {
              normal: {
                color: {
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0.1,
                      color: 'rgba(247, 82, 95, 0.2000)', // 0% 处的颜色
                    },
                    {
                      offset: 0.9,
                      color: 'rgba(247, 82, 95, 0)', // 100% 处的颜色
                    },
                  ],
                  globalCoord: false, // 缺省为 false
                },
              },
            },
          },
        ],
      };
    },
  },
};
</script>
<style lang="scss" >
.all-ll {
  width: 1200px;
  margin: 40px auto;
  height: 100%;
  //text-align: center;
  margin-top: 40px !important;
  display: flex;
  flex-direction: column;
  .Breadcrumb {
    .el-breadcrumb {
      .el-breadcrumb__item {
        .el-breadcrumb__inner {
          color: rgba(209, 212, 220, 1);
          font-size: 14px;
          font-family: MicrosoftYaHei;
          line-height: 22px;
        }
        .el-breadcrumb__separator {
          font-size: 10px;
        }
      }
      .is-l {
        span {
          color: rgba(140, 140, 140, 1) !important;
        }
      }
    }
  }
  .assets-tittle {
    font-size: 24px;
    font-family: MicrosoftYaHei;
    color: #d1d4dc;
    line-height: 31px;
    margin-top: 40px;
  }
  .total-list {
    width: 100%;
    height: 100%;
    background: rgba(159, 159, 159, 0.1);
    margin-top: 24px;
    border-radius: 8px;
    .total-list-mg {
      padding: 24px 24px 40px 32px !important;
      .assets-header {
        // padding: 24px 20px;
        display: flex;
        justify-content: flex-end;
        margin-bottom: 32px;
        .assets-bnt {
          .block {
            .demonstration {
              font-size: 13px;
              font-family: MicrosoftYaHei;
              color: #d1d4dc;
              margin-right: 8px;
            }
            .el-date-editor {
              width: 218px;
              height: 36px;
              background: rgba(209, 212, 220, 0.1);
              border-radius: 4px;
              border: none;
              color: rgba(255, 255, 255, 0.5) !important;
              // 未选中任何选项的时候 placeholder的样式 需要先选中父元素 增加权重
              .el-range-input::-webkit-input-placeholder {
                color: rgba(255, 255, 255, 0.5);
              }
              .el-range-input::-moz-input-placeholder {
                color: rgba(255, 255, 255, 0.5);
              }
              .el-range-input::-ms-input-placeholder {
                color: rgba(255, 255, 255, 0.5);
              }
              //选中后
              .el-range-input {
                cursor: pointer !important;
                color: #d1d4dc !important;
                background: transparent;
                font-size: 12px;
                font-family: Roboto-Regular, Roboto;
                font-weight: 400;
                line-height: 30px;
              }
              .el-range-separator {
                font-size: 12px;
                font-family: MicrosoftYaHei;
                color: #d1d4dc;
                line-height: 30px;
              }
              .el-range__close-icon {
                display: none;
              }
              .el-range__icon {
                font-size: 16px;
                line-height: 30px !important;
              }
            }
          }
        }
      }
      .assets-body {
        .charts {
          height: 400px;
          .right-control {
            height: 120px;
            width: 100%;
            display: flex;
            justify-content: center;
            font-size: 28px;
            line-height: 120px;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss" >
.elDatePicker.el-picker-panel {
  color: #fff !important; //设置当前面板的月份的字体为白色，记为1
  background: #33353e !important; //定义整体面板的颜色
  border: none; //定义整体面板的轮廓
  .el-picker-panel__icon-btn {
    //设置年份月份调节按钮颜色，记为2
    color: #ffffff !important;
  }
  .el-date-picker__header-label {
    //设置年月显示颜色，记为3
    color: #ffffff !important;
  }
  .el-date-table th {
    //设置星期颜色，记为4
    color: #ffffff !important;
  }
}
.el-popper[x-placement^='bottom'] {
  margin-top: 8px !important;
}
.el-picker-panel {
  //color: #bfbfbf;
  border: none !important;
  // -webkit-box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  // box-shadow: 0 2px 12px 0rgba (0, 0, 0, 0.1);
  background: #33353e !important;
  border-radius: 8px 2 !important;

  margin: 5px 0 !important;
  .el-picker-panel__body-wrapper {
    .el-picker-panel__body {
      .el-picker-panel__content {
        .el-date-range-picker__header {
          font-size: 14px !important;
          font-family: Roboto-Regular, Roboto !important;
          font-weight: 400 !important;
          color: #d1d4dc !important;
          .el-picker-panel__icon-btn {
            color: #d9d9d9 !important;
          }
        }
        .el-date-table {
          tr {
            th {
              font-size: 14px !important;
              font-family: MicrosoftYaHei !important;
              color: #bfbfbf !important;
              border-bottom: solid 1px rgba(255, 255, 255, 0.12) !important;
            }
          }
          .el-date-table__row {
            td {
              width: 24px !important;
              height: 24px !important;

              span {
                font-size: 14px !important;
                font-family: Roboto-Regular, Roboto !important;
                font-weight: 400 !important;
                // color: #bfbfbf;
              }
              span:hover {
                background-color: rgba(255, 255, 255, 0.2) !important;
                color: #ffffff !important;
              }
            }
            td:hover {
              color: #ffffff !important;
            }
            .today {
              span {
                font-size: 14px !important;
                font-family: Roboto-Regular, Roboto !important;
                font-weight: 400 !important;
                color: #edbd88 !important;
              }
            }
            .disabled div {
              background-color: #33353e !important;
              cursor: not-allowed !important;
              span {
                color: rgba(191, 191, 191, 0.5) !important;
              }
            }
            .in-range {
              span {
                color: #ffffff !important;
              }
            }
          }
        }
      }
    }
  }
}
.el-date-table td.in-range div,
.el-date-table td.in-range div:hover,
.el-date-table.is-week-mode .el-date-table__row.current div,
.el-date-table.is-week-mode .el-date-table__row:hover div {
  background-color: rgba(255, 255, 255, 0.2) !important;
}
.el-date-table td.start-date div {
  margin-left: 10px !important;
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}
.el-date-table td.end-date div {
  margin-right: 10px !important;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
.el-date-table td.end-date span,
.el-date-table td.start-date span {
  background-color: rgba(239, 195, 148, 1) !important;
}
.el-date-table td span {
  border-radius: 0 !important;
}
.el-date-table td div {
  height: 24px !important;
  padding: 0 !important;
}
.el-date-range-picker__content.is-left {
  border-right: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/CountHistory.vue